import type { FieldDefinition } from '@src/utils/fieldDefinitionUtils';

export const repoBookingFieldDefinitions = {
  direction: {
    title: 'Direction',
    tooltip:
      'Side of the repo for the booking party. Reverse Repo: buy collateral, lend cash. Repo: sell collateral, borrow cash.',
  },
  counterparty: { title: 'Counterparty', tooltip: 'The counterparty to the repo trade' },
  marketAccount: {
    title: 'Market Account',
    tooltip: 'Reference to the governing agreement under which the trade is booked',
  },
  primeBroker: {
    title: 'Prime Broker',
    tooltip: 'Prime broker associated with the repo trade or clearing & settlement workflow',
  },
  quantity: { title: 'Quantity', tooltip: 'Number of units or asset amount for the repo' },
  unitRepoAmount: { title: 'Unit Repo Amount', tooltip: 'Base repo size per unit' },
  repoAmount: { title: 'Repo Amount', tooltip: 'Total collateral amount for the repo' },
  rate: { title: 'Rate', tooltip: 'Annualized interest rate applied to the repo cash consideration' },
  referencePrice: { title: 'Reference Price', tooltip: 'Latest value of Collateral' },
  purchasePrice: {
    title: 'Purchase Price',
    tooltip:
      'Initial cash consideration for the repo. Purchase Price = Collateral Market Value at Reference Price × (1 − Haircut).',
  },
  repoInterest: { title: 'Repo Interest', tooltip: 'Accrued interest on the repo' },
  repurchasePrice: {
    title: 'Repurchase Price',
    tooltip: 'Cash amount due on the closing leg. Repurchase Price = Purchase Price + Accrued Repo Interest.',
  },
  tradeDate: { title: 'Trade Date', tooltip: 'Initial booking date for the repo trade' },
  effectiveDate: { title: 'Effective Date', tooltip: 'Date on which the repo becomes active' },
  expiryTime: { title: 'Repurchase Date', tooltip: 'Date on which the repo matures' },
  settleTime: { title: 'Settlement Date', tooltip: 'Settlement date for the repo' },
  haircutPct: { title: 'Repo Asset Haircut', tooltip: 'Haircut percentage applied to collateral' },
  initialMarginPct: {
    title: 'Initial Margin %',
    tooltip: 'Initial margin percentage. Calculated as 1 / (1 − Haircut %).',
  },
  marginReleasePct: { title: 'Margin Release %', tooltip: 'Margin release threshold percentage' },
  maintenanceMarginPct: { title: 'Maintenance Margin %', tooltip: 'Maintenance margin threshold percentage' },
  marginCallPct: { title: 'Margin Call %', tooltip: 'Margin call threshold percentage' },
  closeOutMarginPct: { title: 'Close-out %', tooltip: 'Close-out margin threshold percentage' },
} as const satisfies Record<string, FieldDefinition>;
